//
//
//
//
//
//

export default {
  name: 'App',
  data: function data() {
    return {};
  },
  created: function created() {
    window.$xss = this.$xss;
  },
  mounted: function mounted() {},
  watch: {
    $route: function $route(New, old) {
      // eslint-disable-next-line no-console
      console.log(New.meta.keepAlive, old.meta.keepAlive);
    }
  }
};